module.exports = __webpack_public_path__ + "static/media/card-empty-gift.19c97a9e.png";